<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { projectService } from "../../../../services/projectservice/project.service";
import { saletransferService } from "../../../../services/saleservice/saletransfer.service";
import { servicehelpers } from "../../../../services/servicehelpers";
import List from "../../../../components/list";
import Screen from "../../../../components/screen";
// import i18n from "../../../../i18n";

/**
 * Contacts-list component
 */
export default {
  extends: Screen,
  page: {
    title: "Sale Transfer Report",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, List },
  data() {
    return {
      ...Screen.Alert,
      ...Screen.Locate,
      saleData: {},
      typeData: {},
      groupData: {},
      floorData: {},
      projectData: {},
      fetchingStats: false,
      title: "Sale Transfer Report",

    };
  },
  mounted() {
    /* eslint-disable no-console */
    this.loadingData();
    this.loadingprojectData();
    
    
    // localStorage.map((item) => {
    //   console.log(JSON.stringify(item));
    // });

  },

  methods: {
    loadingData: function(param = '') {
      this.fetchingStats = false;
      saletransferService.getList(param)
        .then(response => {
          
          this.fetchingStats = true;
          console.log(response)
          this.saleData = response;
        });
    },


    projectChanged: function(event) {
      this.loadingpropertyFloorData(event);
      this.loadingpropertyGroupData(event);
    },

    loadingprojectData: function() {
      projectService.getList()
        .then(response => {
          this.projectData = response;

        });
    },

    loadingpropertyFloorData: function(projectId = 0) {
      servicehelpers.getFloorData(projectId).then(response => {
        this.floorData = response;
      });
    },

    loadingpropertyGroupData: function(projectId = 0) {
      servicehelpers.getGroupData(projectId).then(response => {
        this.groupData = response;
      });
    },


    pageNavigate: function(param) {
      this.loadingData(param);
    },

    submitAdd: function() {
      this.$router.push(this.$route.query.redirectFrom || {
              name: "sale-add",
          });
    },

    //  }, {
    //           name: 'sale.write-off', icon: 'bx bx-x-circle', action: 'writeoff', link: 'property-contract', column: 'id'

  }
};
</script>

<template>
  <Layout>
    <PageHeader :add="{icon: 'bx bx-add-to-queue bx-tada', title: 'general.new', link: 'sale-add'}"
    :title="$t('menuitems.sale.text')" />
    <List v-bind:dataList="saleData" 
          @more="moreClick"
          v-bind:more="{
            sub: [
            {name: 'general.print', icon:'fa fa-print', link: 'report-transfer-sale-print', column: 'id'},
            ]
          }"
          v-bind:filter="{
            search: ['sale_transfers.sale', 'sale_transfers.from_name', 'sale_transfers.to_name', 'sale_transfers.property'],
            dropdown: [{
              title: 'property.project',
              field: 'properties.project_id',
              data: this.projectData.data,
              method: (event) => projectChanged(event),
              default: 1,
              width: 2
            }, {
              title: 'property.group',
              field: 'properties.property_group_id',
              data: this.groupData.data,
            }, {
              title: 'property.floor',
              field: 'properties.project_floor_id',
              show: 'number',
              data: this.floorData.data,
            }],
            date: {
              title: 'general.date',
              field: 'sales.sale_date'
            }
          }"
          v-bind:updating="fetchingStats" 
          v-bind:navigate="pageNavigate"
          v-bind:formats="[
            {name: 'status', color: true}, 
            {name: 'currency_en'}, 
            {name: 'for_date', type: 'date'}, 
            {name: 'expire_date', type: 'date'},
            {name: 'sell_price', type: 'currency', sign: '$'}, 
          ]"
          v-bind:fields="[ 
            `code: ${$t('sale.code')}`, 
            `property: ${$t('property.text')}`, 
            `from_name: ឈ្មោះអតិថិជនចាស់`, 
            `to_name: ឈ្មោះអតិថិជនថ្មី`, 
            `for_date: ${$t('general.date')}`, 
            `sell_price: ${$t('booking.price')}`,
            `fee: តម្លៃសេវាកម្ម`,
            `status: ស្ថានភាព`, 
          ]" />
  </Layout>
</template>

